import axios from 'axios';

// ---- Base URL configuration ---- //
const baseURL =
  window._env_?.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_API_BASE_URL ||
  "https://crclm-backend-dev.bravewave-24971d4f.eastus.azurecontainerapps.io/api";

// ---- Create Axios instance ---- //
const api = axios.create({
  baseURL,
});

// ---- Global interceptor: Attach JWT token automatically ---- //
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ---- Fetch (GET) ---- //
export const fetchData = async (endpoint) => {
  try {
    const response = await api.get(`/${endpoint}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching ${endpoint}:`, error);
    throw error;
  }
};

// ---- POST ---- //
export const postData = async (endpoint, data) => {
  try {
    const isFormData = data instanceof FormData;
    const response = await api.post(`/${endpoint}`, data, {
      headers: isFormData
        ? {}
        : { 'Content-Type': 'application/json' },
    });
    console.log(`Posted to /${endpoint}:`, response.data);
    return response.data;
  } catch (error) {
    console.error(`Error posting to ${endpoint}:`, error.response?.data || error.message);
    throw error;
  }
};

// ---- DELETE ---- //
export const deleteData = async (endpoint, data) => {
  try {
    const response = await api.delete(`/${endpoint}`, {
      headers: { 'Content-Type': 'application/json' },
      data: data,
    });
    console.log(`Deleted from /${endpoint}:`, response.data);
    return response.data;
  } catch (error) {
    console.error(`Error deleting from ${endpoint}:`, error.response?.data || error.message);
    throw error;
  }
};

// ---- PUT ---- //
export const putData = async (endpoint, data) => {
  try {
    const response = await api.put(`/${endpoint}`, data, {
      headers: { 'Content-Type': 'application/json' },
    });
    console.log(`PUT to /${endpoint}:`, response.data);
    return response.data;
  } catch (error) {
    console.error(`Error putting to ${endpoint}:`, error.response?.data || error.message);
    throw error;
  }
};

// ---- Upload profile image ---- //
export const uploadProfileImage = async (data) => {
  try {
    const response = await api.post('/uploadimage', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    console.log('Profile image uploaded:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error uploading profile image:', error.response?.data || error.message);
    throw error;
  }
};

// ---- Email Service (external, unchanged) ---- //
export const sendEmail = async (to, subject, html) => {
  const emailServiceUrl = 'https://crticketingsystem-backend-dev.icyfield-14eece6f.eastus.azurecontainerapps.io/api/send_email';
  try {
    const response = await axios.post(
      emailServiceUrl,
      { to, subject, html },
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );
    console.log(`Email sent to ${to}:`, response.data);
    return response.data;
  } catch (error) {
    console.error(`Error sending email to ${to}:`, error.response?.data || error.message);
    throw error;
  }
};

// ---- Export unified API service ---- //
const apiService = {
  fetchData,
  postData,
  deleteData,
  putData,
  uploadProfileImage,
  sendEmail,
};

export default apiService;
